import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { value } = button
    const postit = button.closest('div.ea_auth__postit')
    const { dataset } = postit
    const { uid } = dataset

    postit.style.setProperty('--ea_postit_background_color', value)

    if (uid) {
      const url = href('auth/postit', {
        modify: 1,
        postit_uid: uid,
        postit_color: value
      })
      globals.ea_link_direct(url, 'nodiv_in', null)
    }
  }
})

export default button => {
  onClick.listen(button)
}
